var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRujLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "100%",
    height: "100%",
    viewBox: "0 0 85.11 85.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient1",
    x1: 11.67,
    y1: 768.69,
    x2: 71.21,
    y2: 828.23,
    gradientTransform: "translate(0 -756)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a57547"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#d2ab7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#be915f"
  })), /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n          fill:#fff;\n        }\n      .cls-2 {\n          fill:url(#Gradient1);\n        }\n    "))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M73.3,7.8a5.08,5.08,0,0,0-1.7.3,3,3,0,0,0-1.3.9,3.81,3.81,0,0,0-.9,1.3,4.69,4.69,0,0,0,0,3.3,4,4,0,0,0,2.2,2.2,4.69,4.69,0,0,0,3.3,0,4,4,0,0,0,2.2-2.2A4.14,4.14,0,0,0,76.2,9,2.26,2.26,0,0,0,75,8.1,4.67,4.67,0,0,0,73.3,7.8Zm0,0.6a3.25,3.25,0,0,1,2.5,1.1,4.44,4.44,0,0,1,.8,1.1,3.42,3.42,0,0,1,0,2.8,2.84,2.84,0,0,1-.8,1.1,3.59,3.59,0,0,1-5,.1,3.17,3.17,0,0,1-.8-1.2,3.42,3.42,0,0,1,0-2.8,3.24,3.24,0,0,1,1.9-1.9A3.93,3.93,0,0,1,73.3,8.4Zm-0.9,6V12.3h1l1.4,2.2h0.7L74,12.3c0.2,0,.3-0.1.5-0.1s0.3-.2.4-0.3a1.38,1.38,0,0,0,.3-0.4,1.27,1.27,0,0,0,.1-0.6,1.28,1.28,0,0,0-.4-1,1.31,1.31,0,0,0-1.2-.3H71.8v4.9l0.6-.1h0Zm0.8-2.7H72.4V10.1h1.5c0.1,0,.3.1,0.4,0.1a0.85,0.85,0,0,1,.3.3,0.6,0.6,0,0,1,.1.4,0.9,0.9,0,0,1-.1.5l-0.3.3a0.9,0.9,0,0,1-.5.1Z",
    transform: "translate(0.05 0.03)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12.5,12.4A42.36,42.36,0,0,1,64.1,5.9L26.4,33.3a7.8,7.8,0,0,0-3.2,6.9,36.33,36.33,0,0,1-.9,10.4,34,34,0,0,1-8.6,15.5L16,68.4,33.4,49.7a5,5,0,0,0,1.1-4.8,8.7,8.7,0,1,1,11,5.5,8.4,8.4,0,0,1-5.2.1,4.87,4.87,0,0,0-4.9,1L16.6,69.1l2.3,2.3a33.57,33.57,0,0,1,15.5-8.6,36.33,36.33,0,0,1,10.4-.9,7.8,7.8,0,0,0,6.9-3.2L79.2,21A42.56,42.56,0,1,1,12.5,12.4Z",
    transform: "translate(0.05 0.03)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRujLogo);
export default __webpack_public_path__ + "static/media/ruj-logo.4b925d86.svg";
export { ForwardRef as ReactComponent };